<template>
    <div class="w-full">
        <div class="w-full flex items-center mb-2">
            <button class="back-btn" @click="hideModal()" aria-label="back">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18l-6-6 6-6" stroke="#11c6db" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h5 class="flex-1 text-center text-base font-semibold pr-6" style="color: var(--nav-bgc);">{{$store.getters.getT("Card Request")}}</h5>
        </div>
        <small class="block mb-3 text-red-500 text-center text-xs" :class="op==1?'opacity-100':'opacity-0'">{{$store.getters.getT("errorMsg")}}</small>

            <div class="mb-3">
                <label for="name" class="field-label">{{$store.getters.getT("FirstName")}}</label>
                <input required type="text" class="field-input" name="name" ref="name" :placeholder="$store.getters.getT('FirstName')" id="name">
            </div>
            <div class="mb-3">
                <label for="surname" class="field-label">{{$store.getters.getT("LastName")}}</label>
                <input required type="text" class="field-input" :placeholder="$store.getters.getT('LastName')" ref="surname" name="surname" id="surname">
            </div>
            <div class="mb-3">
                <label for="phone_number" class="field-label">{{$store.getters.getT("Phone")}}</label>
                <input required type="number" inputmode="numeric" pattern="[0-9]*" min="0" class="field-input" :placeholder="$store.getters.getT('Phone')" ref="phone_number" name="phone_number" id="phone_number">
            </div>
            <div class="mb-3">
                <label for="address" class="field-label">{{$store.getters.getT("adress")}}</label>
                <input required type="text" class="field-input" :placeholder="$store.getters.getT('adress')" ref="address" name="address" id="address">
            </div>
            <div class="mb-3">
                <label for="cardType" class="field-label">{{$store.getters.getT("Card Type")}}</label>
                <select name="cardType" id="cardType" ref="cardType" class="field-input">
                    <option value="platinum">{{$store.getters.getT("Platinum card")}} - 8000 DA</option>
                    <option value="gold">{{$store.getters.getT("Gold card")}} - 9000 DA</option>
                    <option value="classic">{{$store.getters.getT("Classic card")}} - 6000 DA</option>
                </select>
            </div>
            <div class="mb-4">
                <label for="card_id" class="field-label">{{$store.getters.getT("Id Photo")}}</label>
                <div class="field-input file-input relative">
                    <span class="absolute px-3 whitespace-nowrap overflow-hidden overflow-ellipsis w-full text-sm">{{$store.getters.getT(cardName)}}</span>
                    <input required type="file" @change="(chowIdName)" class="w-full h-full opacity-0" name="card_id" ref="card_id" id="card_id" accept="image/*">
                </div>
            </div>
            <div class="w-full flex justify-center">
                <button @click="subForm()" type="submit" :disabled="loading" class="submit-btn disabled:opacity-60">
                    {{ loading ? $store.getters.getT("Redirecting to payment") : $store.getters.getT("Send Request") }}
                </button>
            </div>

    </div>
</template>
<style scoped>
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .back-btn {
        width: 32px;
        height: 32px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #eefbfd;
        transition: background 0.2s ease;
        flex-shrink: 0;
    }
    .back-btn:hover {
        background: #d9f4f8;
    }
    .field-label {
        display: block;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #6b93a1;
        margin-bottom: 4px;
    }
    .field-input {
        display: block;
        width: 100%;
        color: #1c2b33;
        background: #f5fcfd;
        border: 1.5px solid #dff3f6;
        border-radius: 12px;
        padding: 9px 12px;
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }
    .field-input:focus {
        outline: none;
        border-color: #11c6db;
        box-shadow: 0 0 0 3px rgba(17, 198, 219, 0.15);
    }
    .file-input {
        padding: 0;
        height: 38px;
        border-style: dashed;
        display: flex;
        align-items: center;
    }
    .submit-btn {
        width: 100%;
        padding: 10px 16px;
        color: white;
        border-radius: 999px;
        text-transform: uppercase;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.03em;
        background: linear-gradient(135deg, #22c7e5, #0fa8ba);
        box-shadow: 0 8px 18px rgba(17, 198, 219, 0.28);
        transition: transform 0.15s ease, box-shadow 0.15s ease;
    }
    .submit-btn:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 10px 22px rgba(17, 198, 219, 0.35);
    }
</style>
<script>
    import { mapMutations} from 'vuex'
    import { toast } from 'vue3-toastify';
    import 'vue3-toastify/dist/index.css';
    import SlickPayService from "@/services/SlickPayService";
    import { PENDING_CARD_REQUEST_KEY, CARD_PRICES, fileToBase64, generateRib } from "@/services/cardPayment";

    const CARD_TYPE_LABELS = {
        platinum: "Platinum card",
        gold: "Gold card",
        classic: "Classic card",
    };

    // 4MB keeps the base64-encoded id photo comfortably under the ~5MB
    // per-origin localStorage quota it has to survive in while the user is
    // away on the SlickPay/SATIM payment pages.
    const MAX_ID_PHOTO_SIZE = 4 * 1024 * 1024;

    export default {
        data(){
            return{
                cardName:"click to upload a photo of your id",
                op:0,
                loading:false,
            }
        },
        methods: {
            chowIdName(e){
                this.cardName=e.target.files.item(0).name
            },
            hideModal(){
                this.SET_showModal(false)
            },
            ...mapMutations([
                'SET_showModal',
            ]),
            async subForm(){
                if (this.$refs.name.value==""||
                    this.$refs.surname.value==""||
                    this.$refs.phone_number.value==""||
                    this.$refs.address.value==""||
                    this.$refs.card_id.files.length == 0
                ) {
                    this.op=1
                    return
                }
                this.op=0

                const idPhoto = this.$refs.card_id.files.item(0)
                if (idPhoto.size > MAX_ID_PHOTO_SIZE) {
                    toast.error(this.$store.getters.getT("Payment could not be initiated"), {
                        autoClose: 6000,
                        theme: toast.THEME.COLORED,
                    })
                    return
                }

                const name = this.$refs.name.value
                const surname = this.$refs.surname.value
                const phone_number = this.$refs.phone_number.value
                const address = this.$refs.address.value
                const type = this.$refs.cardType.value
                const amount = CARD_PRICES[type] ?? CARD_PRICES.platinum

                this.loading = true
                try {
                    // 1) Create the SlickPay contact for this requester. SlickPay's
                    // sandbox requires firstname/lastname/phone/address/rib (verified
                    // against the live devapi). A RIB has no meaning for someone just
                    // paying a card fee, so it's generated rather than asked for.
                    const contact = await SlickPayService.createContact({
                        firstname: name,
                        lastname: surname,
                        phone: phone_number,
                        address,
                        rib: generateRib(),
                    })
                    const contactUuid = contact.uuid ?? contact.data?.uuid

                    // 2) Create the invoice for the card fee and get the SATIM payment url.
                    // (users/invoices, not transfers - this generates the SATIM
                    // redirect where the user pays with their Edahabia/CIB card.)
                    const returnUrl = `${window.location.origin}/payment-success`
                    const invoice = await SlickPayService.createInvoice({
                        amount,
                        contact: contactUuid,
                        url: returnUrl,
                        items: [
                            {
                                name: `${this.$store.getters.getT("Card Request")} - ${this.$store.getters.getT(CARD_TYPE_LABELS[type] ?? type)}`,
                                price: amount,
                                quantity: 1,
                            },
                        ],
                    })
                    const paymentUrl = invoice.url ?? invoice.data?.url
                    const invoiceId = invoice.id ?? invoice.data?.id
                    if (!paymentUrl || !invoiceId) {
                        throw new Error("Missing payment url/id in SlickPay response")
                    }

                    // 3) Stash the form data (id photo as base64, since a File object
                    // can't survive the trip to SATIM and back) so PaymentSuccess.vue
                    // can finish the card request once the payment is confirmed.
                    const card_id_base64 = await fileToBase64(idPhoto)
                    localStorage.setItem(PENDING_CARD_REQUEST_KEY, JSON.stringify({
                        invoiceId,
                        paymentUrl,
                        name,
                        surname,
                        phone_number,
                        address,
                        type,
                        card_id_base64,
                        card_id_name: idPhoto.name,
                    }))

                    // 4) Off to SlickPay/SATIM to actually pay.
                    window.location.href = paymentUrl
                } catch (error) {
                    console.log(error)
                    this.loading = false
                    toast.error(this.$store.getters.getT("Payment could not be initiated"), {
                        autoClose: 6000,
                        closeButton: true,
                        hideProgressBar: false,
                        position: toast.POSITION.TOP_CENTER,
                        theme: toast.THEME.COLORED,
                    })
                }
            }
        }
    }
</script>
